import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { Button, ButtonGroup } from "aible";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import numeral from "numeral";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleNotch, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import BusinessConstraintsContainer from "containers/Business/Strategy/BusinessConstraints";
import HexGridContainer from "containers/Next/HexGrid";

import Select from "react-select";
import TransformIcon from "images/Next-Icons/TransformIcon.svg";
import JoinIcon from "images/Next-Icons/JoinIcon.svg";
import DropIcon from "images/Next-Icons/DropIcon.svg";
import ExploreIcon from "images/Next-Icons/ExploreIcon.svg";
import TrainIcon from "images/Next-Icons/TrainIcon.svg";
import BlueprintIcon from "images/Next-Icons/BlueprintIcon.svg";
import AibleBadgeIcon from "images/Next-Icons/AibleBadgeIcon.svg";

import * as nextReducer from "containers/Next/NextReducer";

import styles from "./style.module.css";

const hexSize = 128;

export default class Overview extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    setTimeout(() => {
      nextReducer.centerHex({ x: 3, y: 3 });
    }, 100);
  }

  renderMinimap(node) {
    return (
      <div className={styles.minimap}>
        <div className={styles.mGrid}>
          <HexGridContainer id={node.nextId} isMini mType={"MODELS"} />
        </div>
      </div>
    );
  }

  renderHex(hex, x, y, innerHexSize, node, isFaded = false, index) {
    const { handleProjectClick, selectedHex, savedHexMap, handleBack, handleUpdate, hexMap } = this.props;

    const isSelectedHex = selectedHex && selectedHex.x === hex.x && selectedHex.y === hex.y;

    const isStack = hexMap && hex && hexMap[hex.x + "_" + hex.y] && hexMap[hex.x + "_" + hex.y].length > 1;

    const background = node?.background || "blue";

    const hoverColor = isStack ? "rgba(164, 166, 182, 1)" : "rgba(122, 109, 208, 1)";
    const textColor = node?.color || hoverColor;

    const hKey = hex.x + "_" + hex.y;

    return (
      <div
        id={"hexTile_" + hKey}
        key={"hex_" + hKey + "_" + index}
        className={styles.hexHolder}
        style={{
          left: x,
          top: y,
          opacity: 1,
          zIndex: index !== undefined ? index + 2 : 2
        }}
        onClick={
          node?.nextId !== undefined && node?.datasetId !== undefined
            ? () => handleProjectClick(node?.nextId, node?.datasetId)
            : () => {}
        }
        onMouseEnter={() => console.log(node)}
      >
        <div
          className={styles.hexagon}
          style={{
            height: innerHexSize + "px",
            width: innerHexSize * (110 / 190) + "px",
            background: background
          }}
        >
          <div
            className={styles.hTop}
            style={{
              height: innerHexSize + "px",
              width: innerHexSize * (110 / 190) + "px",
              color: textColor
            }}
          >
            <div className={styles.hexTop}>
              {node?.type === "AIBLE" ? (
                <img className={styles.aibleBadgeIcon} src={AibleBadgeIcon} />
              ) : (
                node?.projectId !== undefined && this.renderMinimap(node)
              )}
            </div>
            <div className={styles.hexBot}>
              <div className={styles.hexBotLarge}>{numeral(node.impact).format("0.0a")}</div>
              <div className={styles.hexBotSmall}>{node?.type === "AIBLE" ? "VALUE CREATED BY AIBLE" : node?.type}</div>
            </div>
          </div>
          <div
            className={styles.face1}
            style={{
              background: background
            }}
          ></div>
          <div
            className={styles.face2}
            style={{
              background: background
            }}
          ></div>
        </div>
        <div className={styles.borderHex}>
          <div
            className={styles.hexagon}
            style={{
              height: isStack ? innerHexSize + 5 + "px" : innerHexSize + 6 + "px",
              width: isStack
                ? innerHexSize * (110 / 190) + (5 * 110) / 190 + "px"
                : innerHexSize * (110 / 190) + (6 * 110) / 190 + "px",
              background: hoverColor
            }}
          >
            <div
              className={styles.face1}
              style={{
                background: hoverColor
              }}
            ></div>
            <div
              className={styles.face2}
              style={{
                background: hoverColor
              }}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { hexMap, actionHexMap, selectedHex } = this.props;

    console.log(this.props);

    let hexGrid = [];

    const calcInnerHexSize = (size) => size * 1.65;
    const innerHexSize = calcInnerHexSize(hexSize);

    const Hex = extendHex({
      size: hexSize, // default: 1
      orientation: "flat" // default: 'pointy'
    });

    const Grid = defineGrid(Hex);

    const hasActions = actionHexMap && Object.keys(actionHexMap).length > 0;

    Grid.hexagon({
      radius: 8,
      center: [8, 8]
    }).forEach((hex, i) => {
      const { x, y } = hex.toPoint();

      const rKey = hex.x + "_" + hex.y;

      if (actionHexMap && actionHexMap[rKey]) {
        hexGrid.push(this.renderHex(hex, x, y, innerHexSize, actionHexMap[rKey]));
      } else if (hexMap && hexMap[rKey]) {
        const nodes = hexMap[rKey];

        nodes.forEach((node, i) => {
          hexGrid.push(
            this.renderHex(
              hex,
              x - i * 5,
              y - i * 5,
              innerHexSize,
              node,
              hasActions && (selectedHex === undefined || selectedHex.x !== hex.x || selectedHex.y !== hex.y),
              i
            )
          );
        });
      }
    });

    return hexGrid;
  }
}
